import { newToastEvent } from "../../../utils/ToastUtil";
import TenantAPI from "../../api/TenantAPI";

const useExportData = () => {
  const exportData = async ({
    FileName,
    Query,
    Records,
    moduleAPIName,
    FileType,
    SQLQuery = false,
    MultiSubitemField,
    ParentRecordID,
    GrowthCloudExport,
  }: {
    FileName: string;
    Query: any;
    Records: any;
    moduleAPIName: string;
    FileType: any;
    MultiSubitemField: any;
    ParentRecordID: any;
    GrowthCloudExport: boolean;
    SQLQuery?: boolean;
  }) => {
    try {
      newToastEvent("success", "Exporting Records...", "csv-export", {
        loading: true,
        autoClose: false,
      });

      await TenantAPI.exportData(
        FileName,
        Query,
        Records,
        moduleAPIName,
        FileType,
        MultiSubitemField,
        ParentRecordID,
        GrowthCloudExport,
        SQLQuery
      );
    } catch (e) {
      console.error(e);
    }
  };
  return {
    exportData,
  };
};

export default useExportData;
